import { useCallback, useContext } from 'react';
import api from 'api';
import downloadService from 'services/downloadService';
import DownloadStatusContext from 'providers/DownloadStatus/DownloadStatus.context';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import { getMixpanelErrorProps } from 'axiosUtils';
import { ErrorViewedProps } from 'models/MixpanelEvents';

export default function useStartDownloadingFile() {
  const { startFileDownload, failFileDownload } =
    useContext(DownloadStatusContext);

  const getMixpanelProps = useGetMixpanelProps();

  return useCallback(
    async (nodeId: string) => {
      try {
        startFileDownload();
        await api.dataRoom.nodes.startDownloadingFile(
          nodeId,
          downloadService.downloadUniqueId,
        );
      } catch (e) {
        mixpanelService.errorViewed(
          getMixpanelProps(getMixpanelErrorProps(e)) as ErrorViewedProps,
        );
        failFileDownload();
      }
    },
    [failFileDownload, getMixpanelProps, startFileDownload],
  );
}
